<template>
  <div class="ads1-component">
    <template v-if="adViewType === 'list'">
      <ads-row
        v-for="item in items"
        :key="item.key"
        :param-item="item"
        :user="user"
      />
    </template>
    <template v-if="adViewType === 'grid'">
      <el-col
        v-for="item in items"
        :key="item.key"
        :sm="gridCol"
        :md="gridCol"
        class="ad1-item-wrapper"
      >
        <ads-item :item="item" />
      </el-col>
    </template>
    <div class="clearfix" />
  </div>
</template>
<script>

import { mapState, mapGetters } from 'vuex';
import AdsRow from './AdsRow';
import AdsItem from './AdsItem';

export default {
  components: { AdsItem, AdsRow },
  // eslint-disable-next-line vue/require-prop-types
  props: [ 'adViewType', 'items', 'gridCol', 'user' ],
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
    };
  },
  computed: {
    ...mapState({ isMobile: state => state.isMobile }),

    ...mapGetters(['columns']),

  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Ads/Ads.vue